import { forwardRef } from 'react';
// eslint-disable-next-line no-restricted-imports
import { DateRange as ArcDateRange, DateRangeProps } from 'arc';
import { useEnabledFeatures } from '../common/hooks/enabled-features/use-enabled-features';

export const DateRange = forwardRef<HTMLDivElement, DateRangeProps>(function DateRange(props, ref) {
    const { datePickerForceLeadingZerosEnabled } = useEnabledFeatures();
    return (
        <ArcDateRange
            ref={ref}
            {...props}
            shouldForceLeadingZeros={props.shouldForceLeadingZeros || datePickerForceLeadingZerosEnabled}
        />
    );
});
